export default __webpack_public_path__ + "static/media/witheredblasphemy.848ac38f.png";